import { Api } from '@axiom/ui';
import type { Candidate, CandidateReputation } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateReputationApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readReputationData(candidateId: Candidate['id']) {
    return super.read<{ data: CandidateReputation | null }>({
      endpoint: `/candidates/${candidateId}/reputation`,
      method: 'GET',
    });
  }
}

export const CandidateReputationApi = new CandidateReputationApiClass();
